import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Transaction } from '../models/transaction';
import { MerchantResponseComponent } from '../merchant-response/merchant-response.component';
import { Constants } from '../constants/constants';
import { getQueryParamByName, updateQueryStringParam } from '../common/utils';
import { MerchantResponseData } from '../models/merchant-models';
import { EventTypes } from '../models/enums/event-types';
import { LoadingService } from '../services/loading.service';
import { PaymentRequestService } from '../services/payment-request.service';
import { PaymentService } from '../services/payment.service';
import { GlobalAppData } from '../models/global-app-data';
import { SharedService } from '../services/shared.service';
import { SegmentService } from '../services/segment.service';
import { TranslocoService } from '@jsverse/transloco';
import { faLock } from '@fortawesome/free-solid-svg-icons';
import {  PBBTransactionResponse } from '../models/paybybank';
import {TransactionStatus} from '../models/enums/constants';
import { Payment } from '../models/payment';
import { environment } from '../../environments/environment';
import { MatDialog } from '@angular/material/dialog';
import {PaybybankPopupComponent} from '../paybybank-popup/paybybank-popup.component'
import { PaybybankService } from '../services/paybybank.service';

declare const CP:any;

@Component({
  selector: 'app-pay-by-bank',
  templateUrl: './pay-by-bank.component.html',
  styleUrl: './pay-by-bank.component.css'
})
export class PayByBankComponent implements OnInit {

  billingInformation: FormGroup;
  @Input() orderData: Transaction;
  @ViewChild(MerchantResponseComponent) merchantResponseComponent;
  faLock = faLock;
  @Input('payByBankStatus') payByBankStatus: string;
  regEx=/[_@-]/g;
  isStubEnabled: boolean;
  showStub : boolean;
  // Global OSC codes
  oscCodes: Array<any> = Constants.OSC_SYSTEM_CODES;
  @Input() spcOscCode: string;
  sdkConfiguration:{};
  paymentStatus:string | "";
  paymentReponse:string;
  MAX_ALLOWED_ATTEMPTS: number = environment.MAX_PAYMENT_ALLOWED_ATTEMPTS;

  constructor(
    private fb: FormBuilder,
    private _loading: LoadingService,
    private paymentRequestService: PaymentRequestService,
    private paymentService: PaymentService,
    public gd: GlobalAppData,
    private sharedService: SharedService,
    private ss: SegmentService,
    private tranlocoService:TranslocoService,
    private dialog:MatDialog,
    private pbbService:PaybybankService
  ) {}

  ngOnInit(): void {
    this.isStubEnabled = this.gd.isStubEnabled
    this.initForm();
    if (this.payByBankStatus && this.payByBankStatus !== 'approved'){
      this.handleError();
    }
    CP.apiKey=environment.PBB_API_KEY;
  }

  initForm() {
    this.billingInformation = this.fb.group({
      nameDetails: this.fb.group({
        firstName: new FormControl(null, [
          Validators.minLength(1),
          Validators.required,
        ]),
        lastName: new FormControl(null, [
          Validators.minLength(1),
          Validators.required,
        ]),
        sameAsShippingContactName: new FormControl(),
      }),
      addressDetails: this.fb.group({
        streetAddress1: new FormControl(null, Validators.required),
        streetAddress2: new FormControl(),
        city: new FormControl(null, Validators.required),
        country: new FormControl({value:'US',disabled:true}),
        region: new FormControl({ value: null, disabled: false }),
        zipcode: new FormControl('',[Validators.pattern( Constants.ZIPCODE_US_VALIDATOR_PATTERN), Validators.required, Validators.minLength(5), Validators.maxLength(9)]),
        company: new FormControl(null),
        phoneNumber: new FormControl(
          '',
          Validators.pattern(Constants.PHONENUMBER_VALIDATOR_PATTERN)
        ),
        email: new FormControl(
          '',
          Validators.pattern(Constants.EMAIL_VALIDATOR_PATTERN)
        ),
        sameAsShippingContactAddress: new FormControl(),
      }),
    });
    this.sdkConfiguration={"accessToken":"",
      "fdCustomerId":"0",
      "configId":environment.PBB_CONFIGURATION_ID,
      "encryptionKey":""
    }

  }

  fetchNewtrnsctnAtmptPayByBank(): void {
    this.sharedService.getNewTransactionId(this.gd.transId)
       .then((res: string) => {
         this.gd.transId = res;
         this.gd.attemptCount++;
        updateQueryStringParam('t', res);
      }).catch((error) => {
        if (error && error.status && error.error) {
          console.debug(`error ap new txn attempt ${error?.error}`);
        }
      }).finally(() => {
        this._loading.setLoading(false,'internal');
      });
  }

  redirectToMerchant(urlVal: string): void {
    sessionStorage.clear()
    const paymentActionData = {
      url: urlVal,
      orderTransaction: this.gd.orderTransaction,
      merchantPaymentReq: {},
    } as MerchantResponseData;
    this.merchantResponseComponent.sendResponseToMerchant('PAYBYBANK', paymentActionData);
  }

  redirectToMerchantRejectURL(): void {
    let merchantRejectURL = this.gd.orderTransaction.order.merchantRejectURL;
    if (!merchantRejectURL) {
      merchantRejectURL = this.gd.oscConfig.rejectUrl;
    }
    this.redirectToMerchant(merchantRejectURL);
  }

  getJsonObject(resp:any){
    if(typeof resp === 'string'){
      return JSON.parse(resp)
    }else{
      return JSON.parse(JSON.stringify(resp))
    }
  }

  payByBankTrnsctnDefaultAttempt(){
    const paymentReq = this.paymentRequestService.getBillingPaymentRequest(
      this.billingInformation,
      true
    );
    sessionStorage.setItem('page', this.gd.attemptCount.toLocaleString());

    sessionStorage.setItem('gd', Buffer.from(JSON.stringify(this.gd)).toString('base64'));
    sessionStorage.setItem('sessionid', getQueryParamByName('jSession'));
    this.paymentService
      .createPayment(paymentReq, this.gd.transId, '/paybybank')
      .subscribe({
        next: (result: any) => {
          let pbbTrans=result as PBBTransactionResponse;
          if(pbbTrans.transactionStatus===TransactionStatus.pbbapproved){
            if(this.isStubEnabled){
              this.showStub = true
              this._loading.setLoading(false, 'internal')
              return;
            }
            this.sdkConfiguration["accessToken"]=pbbTrans?.security?.tokenID;
            this.sdkConfiguration["encryptionKey"]=pbbTrans?.security?.publicKey;
            const guestCheckout = CP.GuestCheckout(this.sdkConfiguration, this.createRequestForSDk(paymentReq), (resp)=>{
              // impl logic to call isGeneralError one time -- improvise later
              try {
                  if(resp !=undefined || resp !=null){
                      let jsonResponse=this.getJsonObject(resp);
                      this.pbbService.capturePayByBankOrder(this.gd?.transId,this.getRequestBody(jsonResponse))
                      .then((capresp)=>{
                        console.log("reponse captured successfully : "+capresp);
                      }).catch((err)=>{
                        console.log("error"+err);
                      });

                      if(!this.isGeneralError(jsonResponse)){
                        let pbbResponse=jsonResponse as PBBTransactionResponse;
                        console.log("getting response "+pbbResponse.transactionStatusCode);
                        if(pbbResponse.transactionStatusCode==0){
                            console.log("entering into if block... means success");
                            this._loading.setLoading(true, 'internal');
                            this.ss.track(EventTypes.payByBankApproved);
                            this.redirectToMerchantSuccessURL();
                        }else{
                            this._loading.setLoading(true, 'internal');
                            this.ss.track(EventTypes.payByBankError);
                            this.handleError();
                        }

                      }else{
                        this._loading.setLoading(true, 'internal');
                        this.ss.track(EventTypes.payByBankError);
                        this.handleError();
                      }
                    }else{
                      throw Error("reponse is null")
                    }
                  }catch(e){
                      console.log("INVALID JSON ERROR : "+e)
                  }
            });

            this.dialog.open(PaybybankPopupComponent,{
              width:'125%',
              height:'100%',
              autoFocus:true,
              id:"paybybankpopup",
              maxHeight:"100%",
              maxWidth:'125%'
            });
            guestCheckout.start('sdk-container');
            this._loading.setLoading(false,'internal');
           }else {
            this.handleError();
          }
        },
        error: (error: any) => {
          this.handleError();
        }
    });
  }

  getRequestBody(resp: any): PBBTransactionResponse | null {
    try {
      if (this.isGeneralError(resp)) {
        const pbbResp: PBBTransactionResponse = {
          transactionStatus: resp.payload?.transactionStatus ?? '',
          transactionStatusCode: resp.code ?? 0,
          referenceTransactionID: resp.payload?.referenceTransactionID ?? '',
          transactionStatusDescription: resp.payload?.transactionStatusDescription ?? '',
          merchantTransactionId: resp.payload?.merchantTransactionId ?? '',
          responseVerbiage: resp.payload?.responseVerbiage ?? '',
          security: undefined,
          errorDetails: [],
          teleCheckDetails: undefined
        };
        return pbbResp;
      }

      return resp as PBBTransactionResponse;
    } catch (e) {
      console.error('Invalid JSON input:', e);
      return null;
    }
  }

  createRequestForSDk(paymentreq:Payment){
    return {
      "amount": this.gd.orderTransaction.amount*100,
      "creditDebitIndicator": "D",
      "currencyCode": "USD",
      "merchantTransactionId": this.gd?.orderTransaction?.order?.epmsOrderId+"-"+this.gd?.transId,
      "subscriberID": environment.PBB_SUBSCRIBER_ID,
      "productCode": this.gd?.orderTransaction?.glProjectText,
      "firstName": paymentreq?.billingAddress?.firstName?.replace(this.regEx,""),
      "lastName": paymentreq?.billingAddress?.lastName?.replace(this.regEx,""),
      "email": paymentreq.billingContact.email,
      "phone": paymentreq.billingContact.phoneNumber,
      "addressLine": paymentreq.billingAddress.addressLine1,
      "addressLine2": paymentreq.billingAddress.addressLine2,
      "city": paymentreq.billingAddress.city,
      "state": paymentreq.billingAddress.region,
      "zip": paymentreq.billingAddress.postalCode,
      "checkType": "P",
      "authLang": "en"
    };
  }

 redirectToMerchantSuccessURL(): void {
    let merchantSuccessURL = this.gd.orderTransaction.order.merchantSuccessURL;
    if (!merchantSuccessURL) {
      merchantSuccessURL = this.gd.oscConfig.successUrl;
    }
    this.redirectToMerchant(merchantSuccessURL);
  }

  isGeneralError(resp: any) {
    const jsonString = JSON.stringify(resp);
    try {
      const obj = JSON.parse(jsonString);
      return Object.prototype.hasOwnProperty.call(obj, 'code');
    } catch (e) {
      console.error('Invalid JSON string:', e);
      return false;
    }

  }


  createPayByBankPayment(): void {
    this.gd.paymentType = 'paybybank';
    this.ss.track(EventTypes.payByBankSubmitted);
    this._loading.setLoading(true,'internal');
      this.payByBankTrnsctnDefaultAttempt();
  }

  handleError() {
    this.payByBankStatus = 'paymentError';
    this.billingInformation.reset();
    this.billingInformation=this.fb.group({
      addressDetails: this.fb.group({
        country: new FormControl({value:'US',disabled:true})
      }),
    });
    this.tranlocoService.setActiveLang(this.gd?.orderTransaction?.order?.displayLanguage);
    if (this.gd.attemptCount < this.gd.oscConfig.maxRejectAtmptCount) {
      this.dialog.getDialogById('paybybankpopup')?.close();
      this.fetchNewtrnsctnAtmptPayByBank();
    } else {
      this.redirectToMerchantRejectURL();
    }
  }

  onModalClosed(): void {
    this.showStub = false;
    this.billingInformation.reset();
  }

  onPayByBankStatusStub(status):void{
    this.payByBankStatus = status
  }
}
